'use client';

import type { ParentCompanyItem } from '@/lib/backend-api';
import type { Locale } from '@/lib/i18n-routes';
import { Building2 } from 'lucide-react';
import { LocaleLink } from '@/components/locale-link';
import { generateCompanySlug } from '@/lib/company-utils';
import type { TFunction } from 'i18next';

interface CompanyParentLinkProps {
  t: TFunction;
  parentFlagUrl: string | null;
  parentCompany: ParentCompanyItem;
  locale: Locale;
}

export function CompanyParentLink({
  t,
  parentFlagUrl,
  parentCompany,
  locale,
}: CompanyParentLinkProps) {
  return (
    <div className="flex items-center gap-1 text-xs text-muted-foreground">
      <span className="opacity-70">
        {t('companyDetail.parent')}:
      </span>
      {parentFlagUrl ? (
        <img
          src={parentFlagUrl}
          alt={parentCompany.country_code ?? ''}
          className="h-3.5 w-3.5 shrink-0 rounded-sm object-contain"
        />
      ) : (
        <Building2 className="h-3.5 w-3.5 shrink-0 opacity-70" />
      )}
      {parentCompany.eu_id && parentCompany.register_court ? (
        <LocaleLink
          href={generateCompanySlug(
            {
              name: parentCompany.name,
              registerCourt: parentCompany.register_court,
              registerType:
                parentCompany.register_type ?? undefined,
              registerId: parentCompany.register_id ?? undefined,
            },
            locale,
          )}
          className="opacity-70 hover:underline"
        >
          {parentCompany.name}
        </LocaleLink>
      ) : (
        <span className="opacity-70">{parentCompany.name}</span>
      )}
    </div>
  );
}
